import { shareUrlModal } from '../../constants/modal-type';
import {
  AdditionalActionId,
  BIEvent,
  ProfileActionType,
  Thunk,
  ThunkWithArgs,
} from '../../types';
import { openModalWithCallback } from '../../services/modal';
import { emitBIEventWithPayload } from '../../services/bi-event';
import { Applications } from '../../services/public-api-store';
import { aboutAppDefinitionId } from '../../constants/app-definition-id';
import { aboutPageId } from '../../constants/section-id';

type AdditionalActionsMap = {
  [key in AdditionalActionId]: Thunk;
};

const shareProfile: Thunk = () => async (_, getState, extra) => {
  const { compId, platformAPIs, wixCodeApi, getPublicAPI, experiments } = extra;
  const state = getState();
  const membersAreaAPI = await getPublicAPI(Applications.MembersArea);
  const profileUrl = await membersAreaAPI
    ?.getSectionUrl({
      appDefinitionId: aboutAppDefinitionId,
      sectionId: aboutPageId,
      memberId: state.users.viewed.uid,
      memberSlug: state.users.viewed.slug,
    })
    .catch(() => null);
  const payload = { url: profileUrl ?? null };
  const onConfirm = () => {};

  openModalWithCallback({
    compId,
    modalType: shareUrlModal,
    payload,
    platformAPIs,
    wixCodeApi,
    experiments,
    onConfirm,
  });
  emitBIEventWithPayload({
    state,
    extra,
    biEvent: BIEvent.RoleActionClicked,
    payload: {
      action_type: ProfileActionType.SHARE_PROFILE,
    },
  });
};

const actionsMap: AdditionalActionsMap = {
  [AdditionalActionId.ShareProfile]: shareProfile,
};

export const executeAdditionalAction: ThunkWithArgs<AdditionalActionId> =
  (actionId) => async (dispatch, getState, extra) => {
    const actionHandler = actionsMap[actionId];
    if (!actionHandler) {
      return;
    }
    await actionHandler()(dispatch, getState, extra);
  };
